// extracted by mini-css-extract-plugin
export default {"root":"styles_root__WZa0-","to-do":"styles_to-do__gTp+w","in-progress":"styles_in-progress__K9m00","done":"styles_done__v6RJ+"};